import { ModuleConfig } from '../components/Module';
import { useModuleManifest } from './useModuleManifest';

/**
 * Gets a module config from a previously loaded module manifest.
 * @see useModuleManifest
 * @param name the name of the module in the manifest
 * @returns the module config
 */
export const useModule = (name: string): ModuleConfig => {
  const moduleManifest = useModuleManifest();
  const moduleManifestConfig = moduleManifest?.filter((m) => m.name === name)[0] ?? { appName: '', module: '', url: '' };
  const moduleConfig: ModuleConfig = { appName: moduleManifestConfig.appName, module: moduleManifestConfig.module, url: moduleManifestConfig.url };
  return moduleConfig;
};
